import firebase from 'firebase/app'
import { notification } from 'ant-design-vue'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc',
  authDomain: 'plannervid.firebaseapp.com',
  databaseURL: 'https://plannervid.firebaseio.com',
  projectId: 'plannervid',
  storageBucket: 'plannervid.appspot.com',
  messagingSenderId: '1015973841778',
  appId: '1:1015973841778:web:1911128818557816976beb',
  measurementId: 'G-8H4JT2DX48',
  clientId: '1015973841778-t628ork85c8okkoeuivav2pf8rnfricf.apps.googleusercontent.com',
}

firebase.initializeApp(firebaseConfig)
export const firebaseAuth = firebase.auth()
export const firebaseDatabase = firebase.firestore()
export const firebaseStorage = firebase.storage().ref()
export const firebaseDatabaseStripe = firebase.default.firestore()
export const firebaseFunctions = firebase.app().functions('us-central1')

export async function login(email, password) {
  return firebaseAuth
    .signInWithEmailAndPassword(email, password)
    .then(() => true)
    .catch(error => {
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

// export async function register(email, password, name) {
//   return firebaseAuth
//     .createUserWithEmailAndPassword(email, password)
//     .then(response => {
//       if (response.user) {
//         const { uid } = response.user
//         firebaseDatabase
//           .ref('users')
//           .child(uid)
//           .set({
//             role: 'admin',
//             name,
//           })
//       }
//       return true
//     })
//     .catch(error => {
//       console.log(error)
//       notification.warning({
//         message: error.code,
//         description: error.message,
//       })
//     })
// }

export async function register(email, password, name) {
  return firebase
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then(
      response => {
        if (response.user) {
          firebase.auth().currentUser.updateProfile({
            displayName: name,
          })
        }
        return true
      })
    .catch(error => {
      console.log(error)
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

// export async function currentAccount() {
//   let userLoaded = false
//   function getCurrentUser(auth) {
//     return new Promise((resolve, reject) => {
//       if (userLoaded) {
//         resolve(firebaseAuth.currentUser)
//       }
//       const unsubscribe = auth.onAuthStateChanged(user => {
//         userLoaded = true
//         unsubscribe()
//         const getUserData = async () => {
//           if (user) {
//             const userFields = await firebaseDatabase
//               .ref('users')
//               .child(user.uid)
//               .once('value')
//               .then(snapshot => {
//                 return snapshot.val()
//               })
//             const mergedUser = Object.assign(user, {
//               id: user.uid,
//               name: userFields.name,
//               role: userFields.role,
//               avatar: user.photoUrl,
//             })
//             return mergedUser
//           }
//           return user
//         }
//         resolve(getUserData())
//       }, reject)
//     })
//   }
//   return getCurrentUser(firebaseAuth)
// }

// export async function logout() {
//   return firebaseAuth.signOut().then(() => true)
// }

export async function currentAccount() {
  let userLoaded = false
  function getCurrentUser(auth) {
    return new Promise((resolve, reject) => {
      if (userLoaded) {
        resolve(firebaseAuth.currentUser)
      }
      const unsubscribe = auth.onAuthStateChanged(user => {
        userLoaded = true
        unsubscribe()
        const getUserData = async () => {
          if (user) {
          }
          return user
        }
        resolve(getUserData())
      }, reject)
    })
  }
  return getCurrentUser(firebaseAuth)
}

export async function logout() {
  return firebaseAuth.signOut().then(() => true)
}
